import React from "react"
import { get } from "lodash"
import { Create } from "react-admin"
import { useQueryWithStore, Loading, useTranslate } from "react-admin"
import { Flex } from "rebass"
import { ActionForm, FooterToolbar, BetterPoInventoryForm } from "../components"
import { FormFields } from "./components"

const CreatePOInventories = (props) => {
  const translate = useTranslate()
  const { location } = props
  let paramsPerPage = {}
  let params = {}

  try {
    const newString = decodeURIComponent(location.search).replace(
      "?filter=",
      ""
    )
    const lastIndex = newString.indexOf("}")
    const newWord = newString.substr(0, lastIndex + 1)
    params = JSON.parse(newWord)
    paramsPerPage = JSON.parse(
      '{"' + location.search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value)
      }
    )
  } catch (e) {}

  const { loaded, data } = useQueryWithStore({
    type: "getList",
    resource: "inventories",
    payload: {
      pagination: {
        page: get(paramsPerPage, "page", 1),
        perPage: get(paramsPerPage, "perPage", 10),
      },
      sort: { field: "id", order: "ASC" },
      filter: params,
    },
  })

  if (!loaded) {
    return (
      <Flex
        width={[1]}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        style={{ height: "70vh" }}
      >
        <Loading />
      </Flex>
    )
  }

  const haveData = data && data.length > 0 ? data : []
  const myItems = haveData.map((item) => {
    return {
      result: item,
      product_id: item.product_id,
      promotions: {},
      qty: item.maximum,
    }
  })

  const initialValues = {
    delivery_date: new Date(),
    remarks: "",
    status: "Draft",
    items: myItems,
  }

  return (
    <Create
      {...props}
      actions={
        <ActionForm
          title={"resources.po.new_po"}
          search={get(props, "location.search", "")}
        />
      }
    >
      <BetterPoInventoryForm
        {...props}
        toolbar={<FooterToolbar />}
        typePostUrl={"CREATE"}
        initialValues={initialValues}
        redirect={"list"}
      >
        <FormFields {...props} translate={translate} />
      </BetterPoInventoryForm>
    </Create>
  )
}

export default CreatePOInventories
